import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';

import {
  FETCH_PARAMOUNT_PLUS_TOKEN,
  FETCH_PARAMOUNT_PLUS_USER_INFO,
  CLEAR_PARAMOUNT_PLUS_USER,
  SET_TOKEN_EXPIRY,
  CLEAR_TOKEN_EXPIRY,
} from 'actions/auth';

const INITIAL_STATE = Immutable({
  user: {
    loading: false,
    error: null,
    data: null,
  },
  token: {
    expiresIn: null,
  },
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case `${FETCH_PARAMOUNT_PLUS_USER_INFO}_LOADING`:
      return state.merge(
        {
          user: { loading: true },
        },
        { deep: true },
      );
    case `${FETCH_PARAMOUNT_PLUS_TOKEN}_ERROR`:
    case `${FETCH_PARAMOUNT_PLUS_USER_INFO}_ERROR`:
      return state.merge(
        {
          user: { loading: false, error: action.payload },
        },
        { deep: true },
      );
    case FETCH_PARAMOUNT_PLUS_USER_INFO:
      return state.merge(
        {
          user: {
            loading: false,
            error: null,
            data: action.payload,
          },
        },
        { deep: true },
      );
    case CLEAR_PARAMOUNT_PLUS_USER:
      return state.merge({
        user: {
          loading: false,
          error: null,
          data: null,
        },
      });
    case SET_TOKEN_EXPIRY:
      return state.merge({
        token: {
          expiresIn: action.payload.expiresIn,
        },
      });
    case CLEAR_TOKEN_EXPIRY:
      return state.merge({
        token: {
          expiresIn: null,
        },
      });
    default:
      return state;
  }
};
